import React from 'react';
import SMClickOutsideObserver from 'lib/SMClickOutsideObserver';
import SMNewsListView from './SMNewsListView';
import SMAccountMenuView from './SMAccountMenuView';
import SMOwnerMenuView from './SMOwnerMenuView';
import SMTrackHelper from 'components/helpers/SMTrackHelper';

class SMHeaderNavi extends React.Component {

  componentDidMount() {
    this.clickOutsideObserver = new SMClickOutsideObserver(this);
    this.clickOutsideObserver.attach(()=>{});
  }

  componentWillUnmount() {
    this.clickOutsideObserver.detach();
  }

  welcomeOwnerDidSelect() {
    SMTrackHelper.criteoItem(this.props.currentUser ? this.props.currentUser.email : "", "createOwner");
  }

  signUpDidSelect() {
    SMTrackHelper.criteoBasket("", "createUser", 2000, 1);
  }

  referralDidSelect() {
    ga('send', 'event', 'button', 'click', 'referral header');
  }
  
  renderLoggedIn() {
    let owners = this.props.currentUser.owners;
    let ownerMenu = (owners && owners.length > 0) ? <SMOwnerMenuView currentUser={this.props.currentUser} /> :
      <li><a onClick={this.welcomeOwnerDidSelect.bind(this)} href={Routes.page_path('host_entry')} className="site-header__nav-owner button-green">スペースを掲載する</a></li>;

    return (
      <ul className="site-header__nav sm-hide">
        {ownerMenu}
        <SMNewsListView currentUser={this.props.currentUser} />
        <SMAccountMenuView currentUser={this.props.currentUser} />
        <li>
          <a target="_blank" href="https://help.spacemarket.com/hc" className="site-header__nav-help link-black link-borderless"><span className="help__text">ヘルプ</span></a>
        </li>
        <li>
          <a onClick={this.referralDidSelect.bind(this)} href={Routes.referrals_path()} className="site-header__nav-help link-black link-borderless"><span className="help__text">友だちを招待</span></a>
        </li>
      </ul>
    );
  }

  renderDefault() {
    return (
      <ul className="site-header__nav sm-hide">
        <li>
          <a onClick={this.welcomeOwnerDidSelect.bind(this)} href={Routes.page_path('host_entry')} className="site-header__nav-owner button-green">スペースを掲載する</a>
        </li>
        <li>
          <a onClick={this.signUpDidSelect.bind(this)} href={Routes.new_user_registration_path()} className="site-header__nav-user">
            <p className="site-header__nav-user-name link-black">新規登録</p>
          </a>
        </li>
        <li>
          <a href={Routes.new_user_session_path()} className="site-header__nav-user">
            <p className="site-header__nav-user-name link-black">ログイン</p>
          </a>
        </li>
        <li>
          <a target="_blank" href="https://help.spacemarket.com/hc" className="site-header__nav-help link-black link-borderless"><span className="help__text">ヘルプ</span></a>
        </li>
        <li>
          <a href={Routes.about_index_path()} className="site-header__nav-help link-black link-borderless"><span className="help__text">ご利用ガイド</span></a>
        </li>
      </ul>
    );
  }

  render() {
    return (this.props.currentUser) ? this.renderLoggedIn() : this.renderDefault();
  }
}
export default SMHeaderNavi;



// WEBPACK FOOTER //
// ./app/javascript/components/header/SMHeaderNavi.jsx